import { render, staticRenderFns } from "./LecturerPromotion.vue?vue&type=template&id=67bcf886&scoped=true&"
import script from "./LecturerPromotion.vue?vue&type=script&lang=js&"
export * from "./LecturerPromotion.vue?vue&type=script&lang=js&"
import style0 from "./LecturerPromotion.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./LecturerPromotion.vue?vue&type=style&index=1&id=67bcf886&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bcf886",
  null
  
)

export default component.exports